import { CustomResponse } from './customResponse';
import { RoleCustom } from './role-custom';
import { LANGUAGE } from '../constants/global';
import { GenericFieldExtension } from './generic-field-extension';

export class User extends CustomResponse {
    public roles: RoleCustom[];

    public static empty(): User {
        let locale: string = LANGUAGE + '_' + LANGUAGE.toUpperCase();
        return new User(null, null, 0, null, null, null, true, null, locale, false);
    }

    constructor(
        public responseMessage: string,
        public isAuthenticated: boolean,

        /// ID interno do utilizador
        public ID: number,
        /// Login do utilizador
        public UserName: string,
        /// Nome do utilizador
        public Name: string,
        /// Email do utilizador
        public Email: string,
        /// Define se a conta está activa (quando a true)
        public Active: boolean,
        /// Valor utilizado para integração com sistemas externos.
        public IntegrationID: string,
        /// Identificação da região/língua do utilizador
        public Locale: string,
        /// Indicação se a password precisa de ser alterada
        public PasswordExpired: boolean,        
        /// Número de contacto telefónico
        public Phone?: string,
        /// Número de contacto telefónico móvel
        public Mobile?: string,
        /// Alteração de Password
        public NewPassword?: string,
        /// Confirmação de Alteração de Password
        public ConfirmNewPassword?: string,
        /// Moradas associadas ao user
        public Locations?: any[],
        //Outros campos
        public FieldsExtensions: GenericFieldExtension[] = [],
        //UserCode
        public UserCode?: string,
        //Notes
        public Notes?: string,
        /// Indicação se Tem Dupla Autenticação
        public HasMFA?: boolean,
        //Key Da autenticação 2 fatores
        public MFAKey?: string,
        //Key Da autenticação 2 fatores
        public MandatoryMFAType?: string,
        //Múltiplos ibans
        public MultipleIbans?: UserIban[],

        public EmailTypes?: any[],

        public TaxNumber?: string

    ) {
        super(responseMessage, isAuthenticated);
        this.roles = [new RoleCustom(0, null, false, -1)];
    }
}


export class UserIban {
    public ID: number;
    public Iban: string;
    public Swift: string;
    public UserID: number;
    public isDefault: boolean;
    public Observations: string;
    
    constructor(id: number, iban?: string, swift?: string, userid?: number, isdefault?: boolean, observations?: string){
        this.ID = id;
        this.Iban = iban;
        this.Swift = swift;
        this.UserID = userid;
        this.isDefault = isdefault;
        this.Observations = observations;
    }
}
